import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAutomation } from "../Automation.context";
import { createAutomationInterface } from "../automation.helper";

/**
 * AddAutomationPopup component for creating new automations
 * @author Muskan Thakur
 */
const AddAutomationPopup = ({ anchor, show, onClose, projectId }) => {
  const { user } = useSelector((state) => state.auth);
  const { handleAddAutomation } = useAutomation();

  /* open the sidebar with a new automation */
  useEffect(() => {
    if (show) {
      const teamId = Number(projectId) || user?.myProjectId;
      const isPersonal = !projectId;
      const defaultAutomation = createAutomationInterface();
      
      const newAutomation = {
        ...defaultAutomation,
        teamId: teamId,
        isPersonal: isPersonal,
        createdBy: user?.id,
      };

      handleAddAutomation(newAutomation);
      onClose();
    }
  }, [show, projectId, user, handleAddAutomation, onClose]);

  return null;
};

export default AddAutomationPopup;
